import { Paper, Typography, useTheme } from '@mui/material'
import { isEmpty } from 'lodash'

type TProps = {
  message?: string
}

function Error({ message = '' }: TProps) {
  const theme = useTheme()

  return isEmpty(message) ? null : (
    <Paper
      sx={{
        p: 2,
        backgroundColor: theme.palette.error.main,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      elevation={8}
    >
      <Typography
        component="p"
        variant="body1"
        color={theme.palette.common.white}
      >
        {message}
      </Typography>
    </Paper>
  )
}

export default Error
